<template>
  <div class="app">
    <el-form label-width="100px">
      <el-form-item label="薪资项目：">
        <el-input v-model="name" style="width: 90%" placeholder="平时加班费" disabled/>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input
            v-model="remark"
            style="width: 90%"
            :autosize="{ minRows: 3, maxRows: 6 }"
            type="textarea"
        />
      </el-form-item>

      <h4 style="margin-left: 20px">发放规则：</h4>
      <el-row :gutter="12" class="demo-radius">
        <el-col
            v-for="i in radiusGroup"
            :key="i"
            :span="6"
            :xs="{ span: 12 }">
        </el-col>
      </el-row>
      <el-form>
        <el-row class="bordered-container">
          <el-form-item label="月薪基数：" style="margin: 10px 0px 10px 40px " required>
            <el-input-number v-model="overtimePay" :precision="2" style="width: 200px" min="0"
                             controls-position="right"></el-input-number>
          </el-form-item>
          <el-form-item label="折算系数：" style="margin: 10px 10px 10px 80px" required>
            <el-input-number v-model="conversionCoefficient" :precision="2" style="width: 200px" min="0" max="3" :step="0.01"
                             controls-position="right"></el-input-number>
          </el-form-item>
        </el-row>
      </el-form>
    </el-form>

    <div style="margin-top: 20%;text-align: center ">
      <el-button type="primary" @click="saveButton">保存</el-button>
    </div>

  </div>
</template>

<script>

export default {
  name: "UsualOvertimePay",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      radiusGroup: [],
      overtimePay: '',
      conversionCoefficient:'',
      remark: []
    }
  },

  methods: {
    async saveButton() {
      if (this.overtimePay === null || this.overtimePay === 0) {
        this.$message({
          message: "请填写月薪基数",
          type: "error"
        })
        return;
      }
      if (this.conversionCoefficient ===null||this.conversionCoefficient.length===0){
        this.$message({
          message:"请填写折算系数",
          type:"error"
        })
        return;
      }
      let pageId = {
        id: this.parentData.id
      }
      let params = {
        overtimePay: this.overtimePay,
        conversionCoefficient: this.conversionCoefficient,
        remark: this.remark,
        itemId: pageId.id,
      }
      await this.$http("salaryRuleConfigureService.saveUsualOvertime", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("salaryRuleConfigureService.getClassById", params);
        this.overtimePay = data.overtime_pay;
        this.conversionCoefficient = data.conversion_coefficient;
        this.remark = data.remark;
      }
    }

  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped lang="less">

.demo-radius .title {
  color: var(--el-text-color-regular);
  font-size: 18px;
  margin: 10px 0;
}

.bordered-container {
  border: 0.5px solid lightgrey;
  padding-top: 20px;
  padding-left: 15px;
  width: 95%;
  margin: 10px;
}

.app {
  margin: 20px;
}
</style>